<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="lg:col-6 col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.client">
              Клиент
            </label>
            <crm-client-auto-complete
              [(selectedClient)]="task.client"
              (selectedClientChange)="selectedClient($event)"
              [isError]="$any(errors?.client)"
              [customSearch]="false"
              [showClear]="true"
              [loading]="clientLoading"
              appendTo="body"></crm-client-auto-complete>
            <small
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Описание</label>
            <crm-editor
              [(value)]="task.description"
              height="250px"></crm-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.deadline">
              Дедлайн
            </label>
            <crm-datepicker
              [(value)]="task.deadline"
              [showTime]="true"
              [stepMinute]="15"
              [inputStyleClass]="errors?.deadline ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.deadline"
              class="p-error">
              {{ errors.deadline | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.taskType">
              Тип заявки
            </label>
            <crm-hd-task-type-single-select
              [customRequest]="true"
              [taskTypes]="taskTypes"
              [loading]="taskTypesLoading"
              [(selectedTaskType)]="task.taskType"
              [showClear]="true"
              [styleClass]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
              (selectedTaskTypeChange)="selectTaskType()"
              appendTo="body">
            </crm-hd-task-type-single-select>
            <small
              *ngIf="errors?.taskType"
              class="p-error">
              {{ errors.taskType | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.unit">
              Бизнес единица
            </label>
            <crm-unit-single-select
              [(selectedUnit)]="task.unit"
              [isError]="$any(errors?.unit)"
              [showClear]="true"
              appendTo="body"></crm-unit-single-select>
            <small
              *ngIf="errors?.unit"
              class="p-error">
              {{ errors.unit | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Эпик</label>
            <crm-master-milestone-single-select
              [(selectedMasterMilestone)]="task.masterMilestone"
              [isError]="$any(errors?.masterMilestone)"
              appendTo="body"></crm-master-milestone-single-select>
            <small
              *ngIf="errors?.masterMilestone"
              class="p-error">
              {{ errors.masterMilestone | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Приоритет</label>
            <crm-single-select
              optionValue="name"
              [options]="priorities"
              [(selectedItem)]="task.priority"
              [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-priority="item">
                {{ priority?.value | helpdeskTaskPriorityName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.priority"
              class="p-error">
              {{ errors.priority | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.plannedMin">
              Время план
            </label>
            <p-inputNumber
              [(ngModel)]="task.plannedMin"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.plannedMin }"></p-inputNumber>
            <small
              *ngIf="errors?.plannedMin"
              class="p-error">
              {{ errors.plannedMin | join }}
            </small>
          </div>
        </div>
      </p-card>

      <div
        *ngIf="task.taskType?.entityType?.attributes?.length"
        class="mt-3">
        <p-card header="Дополнительные реквизиты">
          <div class="p-fluid">
            <crm-hd-eav-fields
              mode="form"
              [attributes]="task.taskType.entityType.attributes"
              [values]="task.eavEntity.values"
              [errors]="errors"
              [hdTaskStatusId]="hdTaskStatusId"
              [showRequiredMarker]="isEditForm"></crm-hd-eav-fields>
          </div>
        </p-card>
      </div>
    </div>

    <div class="lg:col-6 col-12 flex gap-3 flex-column">
      <p-card header="Участники">
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.responsible">
              Ответственный
            </label>
            <crm-user-single-select
              [(selectedUser)]="task.responsible"
              [isError]="$any(errors?.responsible)"
              appendTo="body"></crm-user-single-select>
            <small
              *ngIf="errors?.responsible"
              class="p-error">
              {{ errors.responsible | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.externalUser">
              Внешний пользователь
            </label>
            <div class="flex align-items-center gap-1">
              <div class="flex-grow-1">
                <crm-external-user-single-select
                  [customSearch]="true"
                  [entities]="externalUsers"
                  [loading]="externalUsersLoading"
                  [(selectedEntity)]="task.externalUser"
                  [isError]="$any(errors?.externalUser)"
                  [disabled]="!task.client?.id"
                  appendTo="body"></crm-external-user-single-select>
              </div>
              <crm-button
                *ngIf="task.client?.id && task.client?.contragents?.length"
                icon="pi pi-plus"
                styleClass="p-button-success frm-form-control-icon-btn"
                (onClick)="openFormCreateExternalUser()"></crm-button>
            </div>
            <small
              *ngIf="errors?.externalUser"
              class="p-error">
              {{ errors.externalUser | join }}
            </small>
          </div>

          <h3 class="font-medium -mb-2">Аудиторы</h3>
          <p-divider></p-divider>
          <div class="formgrid grid">
            <div class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="requiredFields?.userAuditors">
                Пользователи
              </label>
              <crm-user-multi-select
                [(selectedUsers)]="task.userAuditors"
                [customRequest]="true"
                [isFloatLabel]="false"
                appendTo="body"></crm-user-multi-select>
            </div>

            <div class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="requiredFields?.userGroupAuditors">
                Группы
              </label>
              <crm-user-group-multi-select
                [(selectedUserGroups)]="task.userGroupAuditors"
                [isFloatLabel]="false"
                appendTo="body">
              </crm-user-group-multi-select>
            </div>

            <div class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="requiredFields?.externalUserAuditors">
                Внешние пользователи
              </label>
              <crm-external-user-multi-select
                [(selectedEntities)]="task.externalUserAuditors"
                [clientId]="task.client?.id"
                [requireClientId]="true"
                appendTo="body"></crm-external-user-multi-select>
            </div>
          </div>
        </div>
      </p-card>

      <p-card
        *ngIf="accessService.finance.dealRights.canReadDeal"
        header="Сделка">
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.deal">
              Сделка
            </label>
            <crm-deal-auto-complete
              [(selectedDeal)]="task.deal"
              [isError]="$any(errors?.deal)"
              [showClear]="true"
              appendTo="body"></crm-deal-auto-complete>
            <small
              *ngIf="errors?.deal"
              class="p-error">
              {{ errors.deal | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card
        *ngIf="accessService.project.projectRights.canReadProject"
        header="Задача">
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.project">
              Задача
            </label>
            <crm-project-auto-complete
              [(selectedProject)]="task.project"
              [showClear]="true"
              [isError]="$any(errors?.project)"
              appendTo="body"></crm-project-auto-complete>
            <small
              *ngIf="errors?.project"
              class="p-error">
              {{ errors.project | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="lg:col-6 col-12 flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete && globalService.isAccessRule('HELPDESK:HELPDESK:DELETE_TASKS')"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteTask(task)"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
